import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EmailComponent } from './email/email.component';
import { WhatsappComponent } from './whatsapp/whatsapp.component';
import {ComunicacaoRoutingModule} from "./comunicacao-routing.module";
import {ComponentesModule} from "../../core/componentes/componentes.module";
import { ConfiguracaoEmailComponent } from './configuracao-email/configuracao-email.component';
import { ConfiguracaoWhatsappComponent } from './configuracao-whatsapp/configuracao-whatsapp.component';

@NgModule({
  declarations: [
    EmailComponent,
    WhatsappComponent,
    ConfiguracaoEmailComponent,
    ConfiguracaoWhatsappComponent
  ],
  exports: [
    ConfiguracaoEmailComponent,
    ConfiguracaoWhatsappComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ComunicacaoRoutingModule,
    ComponentesModule
  ]
})
export class ComunicacaoModule { }
